import React from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';
import { Colors } from 'utils/colors';

export const ColorLegend = () => {
  const { t } = useTranslation();
  return (
    <>
      {t(translations.pages.leihbar.daily.colorLegend())}:
      <div
        className="overdue"
        style={{
          backgroundColor: Colors.leihbarBookingOverdueColorLight,
          alignSelf: 'center',
          fontSize: '0.8em',
          border: '1px solid black',
          borderRadius: '0.5em',
          padding: '0.7em'
        }}
      ></div>
      {t(translations.pages.leihbar.daily.overdue())}
      <div
        className="conflicting"
        style={{
          backgroundColor: Colors.leihbarBookingConflictingColorLight,
          alignSelf: 'center',
          fontSize: '0.8em',
          border: '1px solid black',
          borderRadius: '0.5em',
          padding: '0.7em'
        }}
      ></div>
      {t(translations.pages.leihbar.daily.conflicting())}
    </>
  );
};
